var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('NextMaterialSection',{attrs:{"learnMoreButtonMode":"navigate","image-src":"main1.jpg"}}),_c('AboutCompositeSection'),_c('ProductFamilySection2',{attrs:{"info-width":"wide"}}),_c('AreaOfUseSection'),_c('CanWeHelpSection')],1)}
var staticRenderFns = []

export { render, staticRenderFns }